import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";
import { Badge } from "@volca/ui/components/ui/badge";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { useStAdjustmentsSection } from "./st-adjustments-section";

export const StAdjustmentsPreviewHeader = () => {
  const { byTechnician, totals } = useStAdjustmentsSection();

  return (
    <Stack
      direction="row"
      align="center"
      justify="between"
      gap={4}
      className="w-full shrink-0 border-b border-line px-4 py-3"
    >
      <Stack align="start" gap={1} className="min-w-0 shrink-0">
        <Stack direction="row" align="center" gap={2}>
          <Text variant="label">{totals?.pending ?? 0} lines to push</Text>
          <Badge variant="secondary" size="sm">
            Example data
          </Badge>
        </Stack>
        <Text variant="caption" tone="muted">
          {byTechnician.length} technicians with lines pending
        </Text>
      </Stack>
      <Stack
        direction="row"
        align="start"
        justify="end"
        gap={2}
        className="min-w-0 flex-1"
      >
        <InfoIcon
          aria-hidden="true"
          className="mt-0.5 h-4 w-4 shrink-0 text-subtle"
        />
        <Text tone="muted" className="min-w-0 text-right leading-normal">
          <span className="block">
            You can now push your commissions back to ServiceTitan for accurate
            job costing.
          </span>
          <span className="block">
            Let us know if you'd like to enable for your account.
          </span>
        </Text>
      </Stack>
    </Stack>
  );
};
